module.exports = __webpack_public_path__ + "static/media/external-link.9dc642d4.svg";